import React, { useEffect, useState } from "react";
import { Breadcrumb, Layout, Menu, message, theme } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { callApi } from "../api/apiCaller";
import { GreenNotify, RedNotify } from "../helper/helper";

import Privacy from "../pages/privacyPolicies/privacyPolicies";
import routes from "../api/routes";
import {
  messageICon,
  clientIcon,
  subClientIcon,
  numberIcon,
  rateCardIcon
} from "../assets";
import "./layout.css";
import Header2 from "../components/header/header";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Clients from "../pages/clientList/clientList";
import SubClients from "../pages/subClientList/subClientList";
import RateCards from "../pages/rateCards/rateCards";
import Numbers from "../pages/numberList/number";
import Loader from "../components/loader/loader";
import LandingPage from "../pages/landingPage/landingPage";
const { Header, Content, Footer, Sider } = Layout;

const LayoutDashboard = () => {
  const [isloading, setIsLoading] = useState(false);
  const [isOrganizerModalVisible, setIsOrganizerModalVisible] = useState(false);
  const [isPrivacyModalVisible, setIsPrivacyModalVisible] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  let body = {
    device: {
      id: "3242fwefwe4324",
      deviceToken: "ewtfefwfwerer435dsfhjdsfghjesf",
    },
  };
  const logOut = () => {
    callApi(
      "POST",
      `${routes.logout}`,
      body,
      setIsLoading,
      (res) => {
        console.log("Logout response", res);

        if (res.status === 200) {
          GreenNotify("Logout Successful");
          localStorage.clear();
          navigate("/login", { replace: true });
        } else {
          localStorage.clear();
          navigate("/login", { replace: true });
        }
      },
      (error) => {
        RedNotify("Error occurred while logging out");
        localStorage.clear();
      }
    );
  };

  useEffect(() => {
    return () => setIsLoading(false);
  }, []);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Loader loading={isloading} />
      <Sider style={{ background: "#0B1B2D" }} width={280}>
        <div
          style={{
            padding: "2rem 0",
            textAlign: "center",
            color: "white",
            fontSize: "3rem",
            scrollBehavior: "smooth",
            position: "sticky",
            borderBottom: "10px",
            height: "250px",
          }}
        >
          <h5>INTERACT GLOBAL</h5>
        </div>
        <Menu
          style={{ marginTop: "30px" }}
          inlineCollapsed={true}
          theme="dark"
          defaultSelectedKeys={["1"]}
          mode="inline"
        >
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/clients")}
            icon={<img className="side-bar-icon" src={clientIcon} />}
            key="1"
          >
            Clients
          </Menu.Item>
          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/sub-clients")}
            icon={<img className="side-bar-icon" src={subClientIcon} />}
            key="2"
          >
            Sub Clients
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/numbers")}
            icon={<img className="side-bar-icon" src={numberIcon} />}
            key="3"
          >
            Numbers
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/videos")}
            icon={<img className="side-bar-icon" src={messageICon} />}
            key="4"
          >
            Messages
          </Menu.Item>

          <Menu.Item
            style={{ marginBottom: "3rem", color: "white", fontWeight: "bold" }}
            onClick={() => navigate("/rate-cards")}
            icon={<img className="side-bar-icon" src={rateCardIcon} />}
            key="5"
          >
            Rate Cards
          </Menu.Item>

          <Menu.Item
            onClick={logOut}
            key="11"
            icon={<LogoutOutlined className="side-bar-icon" />}
          >
            Log Out
          </Menu.Item>
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header2 />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/landing-page" element={<LandingPage />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/sub-clients" element={<SubClients />} />
            <Route path="/numbers" element={<Numbers />} />
            <Route path="/rate-cards" element={<RateCards />} />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
